import { createContext } from "react";

import type { AuthenticationStore } from "./AuthenticationStore";

export const AuthenticationStoreContext = createContext<AuthenticationStore | null>(null);
